import { FontEntry } from '../../types/font'

export const neueHaasGroteskText: FontEntry = {
  displayName: 'neue-haas-grotesk-text',
  weights: {
    400: {
      normal: { file: 'NHaasGroteskTXPro-55Rg', extension: 'otf', format: 'opentype' },
      italic: { file: 'NHaasGroteskTXPro-56It', extension: 'otf', format: 'opentype' }
    },
    700: {
      normal: { file: 'NHaasGroteskTXPro-75Bd', extension: 'otf', format: 'opentype' },
      italic: null
    }
  }
}
